import React from 'react';
import { View, ViewStyle, StyleProp } from 'react-native';

type NativeProgressBarProps = {
  value?: number;
  max?: number;
  height?: number;
  backgroundColor?: string;
  fillColor?: string;
  style?: StyleProp<ViewStyle>;
  fillStyle?: StyleProp<ViewStyle>;
};

/**
 * RN-safe progress bar (avoids Tamagui Progress.Indicator translateX bug on native).
 */
const NativeProgressBar = ({
  value = 0,
  max = 100,
  height = 4,
  backgroundColor = 'rgba(0, 0, 0, 0.08)',
  fillColor = '#1976d2',
  style,
  fillStyle,
}: NativeProgressBarProps) => {
  const pct = max > 0 ? Math.min(100, Math.max(0, ((value ?? 0) / max) * 100)) : 0;

  return (
    <View
      style={[
        {
          height,
          borderRadius: height / 2,
          overflow: 'hidden',
          backgroundColor,
          width: '100%',
        },
        style,
      ]}
    >
      <View
        style={[
          {
            height: '100%',
            width: `${pct}%`,
            backgroundColor: fillColor,
            borderRadius: height / 2,
          },
          fillStyle,
        ]}
      />
    </View>
  );
};

export default NativeProgressBar;
